import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { ResultsSection } from '../components/sections/ResultsSection';
import { AudienceSection } from '../components/sections/AudienceSection';
import { BenefitsSection } from '../components/sections/BenefitsSection';
import { CredibilitySection } from '../components/sections/CredibilitySection';
import { PricingSection } from '../components/sections/PricingSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { TestimonialSection } from '../components/sections/TestimonialSection';
import { FAQSection } from '../components/sections/FAQSection';
import { FooterSection } from '../components/sections/FooterSection';
import { SocialProofPopup } from '../components/ui/SocialProofPopup';
export function LandingPage() {
  return <main className="min-h-screen bg-background text-gray-700 font-body selection:bg-primary/30 selection:text-white" data-id="element-321">
      <HeroSection data-id="element-322" />
      <ProblemSection data-id="element-323" />
      <SolutionSection data-id="element-324" />
      <AudienceSection data-id="element-325" />
      <ResultsSection data-id="element-326" />
      <BenefitsSection data-id="element-327" />
      <PricingSection data-id="element-328" />
      <CredibilitySection data-id="element-329" />
      <HowItWorksSection data-id="element-330" />
      <TestimonialSection data-id="element-331" />
      <FAQSection data-id="element-332" />
      <FooterSection data-id="element-333" />
      <SocialProofPopup data-id="element-334" />
    </main>;
}